












import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { listReq } from "@/common/class/h5/index";
import {
  getPublishedItinerary,
  getUsername,
} from "@/api/scheduleManagement/index";
import { Icon, Toast } from "vant";
@Component({
  components: {
    [Icon.name]: Icon,
  },
})
export default class empowermentQueryComponent extends Vue {
  username = "";
  created() {
    let token = localStorage.getItem("token");
    console.log("token");
    console.log(token);
    if (token) {
      this.getUser();
    }
  }

  mounted() {}
  //获取用户名
  getUser() {
    getUsername({})
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.username = data.name;
        }
      })
      .finally(() => {});
  }
  goMyPersonal() {
    let token = localStorage.getItem("token");
    if (token) {
      this.$router.push("personal");
    } else {
      this.$router.push("/login");
    }
  }
  goHome() {
    this.$router.push("home");
  }
}
